import React from "react";
import bannerImg from "../../assets/images/skinefit/imgs/Artboard 18.jpg";
import { TiTick } from "react-icons/ti";
import { IoMdCheckmark } from "react-icons/io";

const Hero = () => {
  return (
    <div
      className={`w-full  min-h-[90vh]  flex flex-col md:flex-row items-center`}
    >
      {/* h-[350px] */}

      <div
        className={`w-[90%] md:pt-10 pb-5  h-1/2 md:w-1/2  md:h-full flex justify-center md:justify-center items-center   `}
      >
        <img
          src={bannerImg}
          className="h-full w-4/5 mt-14 md:mt-0 md:h-2/5 lg:h-[400px] lg:w-[400px] md:w-[80%]   object-cover object-center md:py-0"
          alt=""
        />
      </div>
      <div
        className={`w-[90%] my-5 md:my-0 md:w-1/2 h-1/2  flex flex-col justify-center md:justify-center items-start 
   `}
      >
        <div className="flex flex-col gap-3 ">
          <p className="text-lg md:text-3xl tracking-wide ">
            Discover your perfect path to flawless skin
            <br />
            Begin your new skincare journey today!
          </p>
          <p className="italic">Four Steps to Flawless</p>
          <p>Every OUNCE of our product includes:</p>
          <ul>
            <li className="flex items-center gap-2">
              <IoMdCheckmark size={20} /> Serum
            </li>
            <li className="flex items-center gap-2">
              <IoMdCheckmark size={20} /> Essence
            </li>
            <li className="flex items-center gap-2">
              <IoMdCheckmark size={20} /> Emulsion
            </li>
            <li className="flex items-center gap-2">
              <IoMdCheckmark size={20} /> Nourishing Cream
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Hero;
